module.exports = __webpack_public_path__ + "img/4879a22.png";